import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { TopNavbar } from './TopNavbar';
import { useNavigate } from 'react-router-dom';
import { ChatWidget } from '@/components/chat/ChatWidget';

export const DashboardLayout = ({ 
  children, 
  role = 'client', 
  title = 'Dashboard',
  user = {}
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    // Clear any stored auth data
    localStorage.removeItem('user');
    localStorage.removeItem('role');
    navigate('/login');
  };

  return (
    <div className="dashboard-layout">
      {/* Sidebar - desktop */}
      <div className="hidden lg:block">
        <Sidebar role={role} onLogout={handleLogout} />
      </div>

      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <>
          <div 
            className="fixed inset-0 z-40 bg-background/80 backdrop-blur-sm lg:hidden" 
            onClick={() => setSidebarOpen(false)}
          />
          <div className="fixed inset-y-0 left-0 z-50 w-64 lg:hidden">
            <Sidebar role={role} onLogout={handleLogout} />
          </div>
        </>
      )}

      {/* Main content */}
      <div className="dashboard-main flex-1">
        <TopNavbar 
          title={title} 
          user={user}
          onMenuClick={() => setSidebarOpen(!sidebarOpen)}
        />
        <main className="flex-1 overflow-y-auto bg-background p-6">
          <div className="mx-auto max-w-7xl">
            {children}
          </div>
        </main>
      </div>
      
      {/* Chat Widget for clients */}
      <ChatWidget />
    </div>
  );
};
